import React from 'react';
import { EntitlementDetails } from '@css-xp/graphtypes/src/generated-types-new';
import { SummarySectionV2, CopyableText } from '@css-xp/base';
import { Link } from 'react-router-dom';

export const PageUrlSection = ({ entitlement }: { entitlement: EntitlementDetails }) => {
  const { cloudSiteCustomHostname } = entitlement;
  return (
    <SummarySectionV2.SummaryGridCalloutItem testId="summary-page-url">
      <div className="billing-plan">
        <label>Page URL</label>
        <div className="entitlement-details-column copy-link">
          {cloudSiteCustomHostname ? (
            <CopyableText duration={0}>
              <Link to="#">{cloudSiteCustomHostname}</Link>
            </CopyableText>
          ) : (
            <span className="data-unavailable"> N/A </span>
          )}
        </div>
      </div>
    </SummarySectionV2.SummaryGridCalloutItem>
  );
};
